let retry = 5;
const rInterval = setInterval(() => {
    [
        '.button--primary',
        '.button--secondary'
    ].forEach(el => {
        /**
         * @type {HTMLElement[]}
         */
        const button = [...document.querySelectorAll(el)];
        button.forEach(b => {
            if (!b.classList.contains('animated')) {
                const span = b.querySelector('span');
                if (span) {
                    span.style.transition = '.3s ease-in-out';
                    span.style.whiteSpace = 'nowrap';
                    const newSpan = span.cloneNode(true);
                    b.appendChild(newSpan);
                } else {
                    const content = b.textContent;
                    b.innerHTML = `<span style="transition: .3s ease-in-out !important;;white-space: nowrap">${content}</span><span style="transition: .3s ease-in-out !important;white-space: nowrap">${content}</span>`;
                }
                b.classList.add('animated');
            }
        });
    });
    if (retry === 0) {
        // clearInterval(rInterval);
    }
    // retry--;
}, 1000);